'use client';

import Image from 'next/image';
import styles from './HeroSection.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';

interface HeroSectionProps {
  bgImage: string;
  title: string;
  subtitle?: string;
  inlineSubtitle?: string;
  bgVideo?: string;
  isImage: boolean;
  maskFissures?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ bgImage, title, subtitle, inlineSubtitle, isImage, bgVideo, maskFissures }) => {
  const blurDataURL =
    "data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAACwAQCdASoKAAcABABoJaQAAubM35UsAP5BNtJBDScNqulWT9bIW";
  useAOS();

  return (
    <section aria-label="Hero section" className={styles.heroSection}>
      {isImage && <Image
        src={bgImage}
        alt="Hero background"
        // @ts-ignore
        fill
        priority
        quality={80}
        sizes="100vw"
        className={styles.heroImage}
        style={{ objectFit: "cover" }}
        placeholder="blur"
        blurDataURL={blurDataURL}
      />}

      <Image
        src={maskFissures ?? ""}
        alt="Fissures décoratives"
        // @ts-ignore
        fill
        className={styles.fissures}
        style={{ objectFit: "cover" }}
        data-aos='zoom-in'
      />
      {!isImage && <div className={styles.videoContainer} data-aos='fade'>
        <video
          autoPlay
          loop
          muted
          playsInline
          className={styles.videoBg}
        >
          <source src={bgVideo ?? ""} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>}

      {/* Gradient overlay */}
      <div className={styles.heroOverlay}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{title}</h1>
          {subtitle && <p className={styles.heroSubtitle}>{subtitle} <span className={styles.inlineSubtitle}>{inlineSubtitle}</span></p>}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
